import { FC } from "react";

import classes from "./VotePair.module.css";
import { VoteModelDocument } from "./Vote";
import { BattleModelDocument } from "../image/Image";
import { getLang, i18n } from "../../i18n";

interface Props extends VoteModelDocument {
  isResult: boolean;
  battle?: BattleModelDocument;
}

const VotePair: FC<Props> = ({
  isResult,
  selectedArtworkID,
  expertRate,
  prevExpertRate,
  //reward,
  battle,
  artwork1Src,
  artwork2Src,
}) => {
  const lang = getLang();
  const t = i18n.votePair[lang];

  const win =
    isResult && battle
      ? selectedArtworkID === battle.winnerArtworkID
        ? true
        : false
      : false;
  return (
    <div className={`${classes.votepair} ${isResult ? classes.isResult : ""}`}>
      <div className={classes.images}>
        <div
          className={`${classes.img} ${
            battle && selectedArtworkID === battle.artwork1ID
              ? classes.voted
              : ""
          }`}
        >
          <img src={artwork1Src} alt="" />
          <div
            className={`${classes.score} ${
              battle && battle.artwork1VotesCount >= battle.artwork2VotesCount
                ? classes.win
                : classes.lose
            }`}
          >
            {battle ? battle.artwork1VotesCount : 0}
          </div>
        </div>

        <div
          className={`${classes.img} ${
            battle && selectedArtworkID === battle.artwork2ID
              ? classes.voted
              : ""
          }`}
        >
          <img src={artwork2Src} alt="" />
          <div
            className={`${classes.score} ${
              battle && battle.artwork2VotesCount >= battle.artwork1VotesCount
                ? classes.win
                : classes.lose
            }`}
          >
            {battle ? battle.artwork2VotesCount : 0}
          </div>
        </div>
      </div>

      {isResult && (
        <div
          className={`${classes.results} ${
            win ? classes.resultWin : classes.resultLose
          }`}
        >
          <div className={classes.winrate}>
            <div className={classes.label}>{t.expertRateShort}</div>
            <div className={classes.value}>
              {`${((prevExpertRate || 0) * 100).toFixed(0)}%`}{" "}
              {t.expertRateArrow} {(expertRate * 100).toFixed(0)}%
            </div>
          </div>

          {/* Reward block preserved for future
        <div className={classes.money}>
          <div className={classes.label}>{t.reward}</div>
          <div className={classes.value}>
            +{reward ? reward.toFixed(0) : ""}{" "}
            <span className={classes.coin}>🌕</span>
          </div>
        </div>
        */}
        </div>
      )}
    </div>
  );
};

export default VotePair;
